(function () {
  'use strict';

  if (window.PGUKCheckoutPriorityV101Installed) return;
  window.PGUKCheckoutPriorityV101Installed = true;

  var timer = null;

  function textOf(element) {
    return String((element && (element.value || element.getAttribute('aria-label') || element.innerText || element.textContent)) || '')
      .replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function nativeCheckout(scope) {
    return scope && scope.querySelector('[data-minicart-checkout-button], .pg-cart__checkout-btn, [name="checkout"]');
  }

  function onwardPrimary(scope) {
    if (!scope) return null;
    var controls = scope.querySelectorAll('a, button, [role="button"], input[type="button"], input[type="submit"]');
    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      if (control.matches('[data-minicart-checkout-button], .pg-cart__checkout-btn, [name="checkout"]')) continue;
      var label = textOf(control);
      if (!label || /continue without|view full cart|continue shopping|apple pay|google pay|klarna|shop pay|paypal/.test(label)) continue;
      var attrs = ((control.id || '') + ' ' + (typeof control.className === 'string' ? control.className : '')).toLowerCase();
      var parent = control.parentElement;
      while (parent && parent !== scope) {
        attrs += ' ' + ((parent.id || '') + ' ' + (typeof parent.className === 'string' ? parent.className : '')).toLowerCase();
        parent = parent.parentElement;
      }
      if (/onward|checkoutplus|checkout-plus|checkout_plus/.test(attrs) || /^checkout\+/.test(label)) return control;
    }
    return null;
  }

  function syncScope(scope) {
    if (!scope) return;
    var nativeButton = nativeCheckout(scope);
    var onward = onwardPrimary(scope);
    if (!nativeButton) return;

    nativeButton.classList.remove('pg-native-checkout-hidden-when-onward');
    nativeButton.setAttribute('data-pg-uk-native-primary', 'true');

    if (!onward) return;
    onward.setAttribute('data-pg-uk-onward-secondary', 'true');

    var nativeContainer = nativeButton.closest('.pg-cart__checkout, .checkout, .cart_checkout, .cart__checkout, .cart_content__checkout, div') || nativeButton;
    var onwardContainer = onward.closest('[data-onward], [class*="onward"], [id*="onward"], [class*="checkoutplus"], [class*="checkout-plus"]') || onward;

    if (nativeContainer !== onwardContainer && onwardContainer.parentNode && nativeContainer.parentNode === onwardContainer.parentNode) {
      onwardContainer.parentNode.insertBefore(nativeContainer, onwardContainer);
    } else if (nativeButton.parentNode && onward.parentNode === nativeButton.parentNode && nativeButton.nextSibling !== onward) {
      nativeButton.parentNode.insertBefore(nativeButton, onward);
    }
  }

  function syncAll() {
    timer = null;
    syncScope(document.querySelector('.cart_content'));
    syncScope(document.querySelector('#pg-cart .pg-cart__summary'));
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncAll, delay == null ? 0 : delay);
  }

  function boot() {
    syncAll();
    ['cart:refresh', 'pg:cart-form-patched', 'pg:cart-synchronised', 'shopify:cart:lines-update'].forEach(function (name) {
      document.addEventListener(name, function () { schedule(10); });
    });
    if (window.MutationObserver && document.body) {
      new MutationObserver(function () { schedule(20); }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
    [100, 350, 900, 1800, 3500].forEach(function (delay) { window.setTimeout(syncAll, delay); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
